module.exports = __webpack_public_path__ + "img/ausindustry-diser-crcp-logo.7257eac0.svg";